'use strict';

exports.__esModule = true;
exports.wSpyLog = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function wSpyLog() {
  try {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
      //eslint-disable-line lodash/prefer-lodash-typecheck
      _lodash2.default.invoke.apply(_lodash2.default, [window, 'parent.wSpy.log'].concat(args));
    } else if ((typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object' && self.wSpy) {
      //eslint-disable-line lodash/prefer-lodash-typecheck
      _lodash2.default.invoke.apply(_lodash2.default, [self, 'wSpy.log'].concat(args));
    }
  } catch (e) {} //eslint-disable-line no-empty
}

exports.wSpyLog = wSpyLog;
//# sourceMappingURL=wSpyLog.js.map